import React from "react";

const Aboutme = ({paragraph, secondParagraph}) => {
  return (
    <section className="bg-gray-100 py-16 px-6">
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Left Side - Title */}
        <div className="flex items-center">
          <h2 className="text-2xl font-semibold text-gray-800 self-start">About me</h2>
        </div>

        {/* Right Side - Description */}
        <div className="flex flex-col justify-center">
          <p className="text-gray-700 text-lg leading-relaxed">
            {paragraph}
          </p>
          <p className="text-gray-700 text-lg leading-relaxed mt-4">
            {secondParagraph}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Aboutme;
